import { LaboratoryType } from './laboratory.model';

// ── Enum des rôles (miroir du back-end) ─────────────────────
export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  USER = 'USER',
  ADMIN = 'ADMIN',
  ADMIN_SUPPORT = 'ADMIN_SUPPORT',
  COMMERCIAL = 'COMMERCIAL',
}

// ── Interface utilisateur exposée au client ─────────────────
export interface User {
  _id: string;
  email: string;
  name: string;
  role: UserRole;
  labName?: string;
  labLogoPath?: string | null;
  laboratoryId?: string | null;
  labType?: LaboratoryType;
}

// ── DTO retourné par POST /api/auth/login ───────────────────
export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

// ── Utilisateurs gérés en back-office (CRUD) ─────────────────
export type ManagedUserRole = UserRole.USER | UserRole.ADMIN | UserRole.ADMIN_SUPPORT;

export const MANAGED_USER_ROLE_LABELS: Record<ManagedUserRole, string> = {
  [UserRole.USER]: 'Utilisateur',
  [UserRole.ADMIN]: 'Administrateur',
  [UserRole.ADMIN_SUPPORT]: 'Administrateur Support',
};

export interface ManagedUser {
  _id: string;
  firstName: string;
  lastName: string;
  username: string;
  role: ManagedUserRole;
  laboratoryId?: string | null;
  laboratory?: { name: string } | null;
  email?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserDto {
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  role: ManagedUserRole;
  laboratoryId?: string | null;
  email?: string | null;
}

export interface UpdateUserDto {
  firstName?: string;
  lastName?: string;
  username?: string;
  password?: string;
  role?: ManagedUserRole;
  laboratoryId?: string | null;
  email?: string | null;
}
